const sidebarNav = [
  // {
  //   link: "/",
  //   section: "Dashboard",
  //   icon: "lucide:layout-dashboard",
  //   text: "Dashboard",
  // },
  // {
  //   link: "/blogs",
  //   section: "blogs",
  //   icon: "material-symbols:article-outline",
  //   text: "Blogs",
  // },
  {
    link: "/careers",
    section: "Careers",
    icon: "mdi:briefcase-outline",
    text: "Careers",
  },
  {
    link: "/applications",
    section: "Applications",
    icon: "mdi:file-account-outline",
    text: "Applications",
  },
  {
    link: "/documents",
    section: "Documents",
    icon: "mdi:file-upload-outline",
    text: "Documents",
  },
  // {
  //   link: "/case-studies",
  //   section: "case-studies",
  //   icon: "mdi:book-open-variant-outline",
  //   text: "Case Studies",
  // },
  // {
  //   link: "/contact-submissions",
  //   section: "contact-submissions",
  //   icon: "mdi:email-outline",
  //   text: "Contact Submissions",
  // },
  // {
  //   link: "/assets",
  //   section: "assets",
  //   icon: "mdi:folder-outline",
  //   text: "Assets",
  // },
  // {
  //   link: "/settings",
  //   section: "settings",
  //   icon: "lucide:settings",
  //   text: "Settings",
  // },
];

export default sidebarNav;
